module.exports = Em.Handlebars.compile("{{collection bodyViewClass controllerBinding=\"view.controller\" contentBinding=\"view.controller.records\"}}\n");